import React from "react"

import { ICheckbox } from "./model"

import "./style.scss"

/**
 * Generic Checkbox for use throughout all applications.
 */
export function Checkbox({
    id,
    error,
    required,
    style,
    name,
    className,
    checked,
    callback,
    children,
    direction,
}: ICheckbox) {
    return (
        <div className={`ipc ${className || ""} ${error ? "error" : ""}`} style={style} id={`${id || ""}`}>
            <label>
                {direction === "rtl" && (
                    <div className="ipc-label">
                        {children}
                        {required && <span> *</span>}
                    </div>
                )}
                <div className={`ipc-checkbox ${checked ? "active" : ""}`}>
                    <svg version="1.1" id="tick" x="0px" y="0px" viewBox="0 0 37 37">
                        <polyline
                            className="tick path"
                            style={{
                                fill: "none",
                                strokeWidth: 4,
                                strokeLinejoin: "round",
                                strokeMiterlimit: 10,
                            }}
                            points="11.6,20 15.9,24.2 26.4,13.8 "
                        />
                    </svg>
                </div>
                {direction === "ltr" && (
                    <div className="ipc-label">
                        {children}
                        {required && <span> *</span>}
                    </div>
                )}
                <input name={name} type="checkbox" checked={checked} onChange={callback} />
            </label>
        </div>
    )
}

export default Checkbox

Checkbox.defaultProps = {
    direction: "ltr",
}
